import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Bio from './components/Bio.vue'
import Portfolio from './components/Portfolio.vue'

Vue.use(VueRouter)


const routes = [
  {path: '/bio', component: Bio},
  {path: '/', component: Portfolio}
]

const router = new VueRouter({
  routes: routes
})

Vue.config.productionTip = false

new Vue({
  router: router,
  render: h => h(App)
}).$mount('#app')
